import ProjectHeroEasyServices from "../../../components/ProjectHero/EasyServices/ProjectHeroEasyServices";
import ProjectDetailsEasyServices from "../../../components/ProjectDetails/EasyServices/ProjectDetailsEasyServices";


function ProjectPageEasyServices() {
    return (
        <>
            <ProjectHeroEasyServices />
            <ProjectDetailsEasyServices />
        </>
    )
}

export default ProjectPageEasyServices;